import {
  Box,
  Button,
  Grid,
  Heading,
  HStack,
  Image,
  Select,
  Text,
  VStack,
  SimpleGrid,
} from "@chakra-ui/react";
import { useState } from "react";

const newsData = [
  { title: "Sanket", date: "12/12/2025", image: "/svg/News.png" },
  { title: "Sanket", date: "12/12/2025", image: "/svg/News.png" },
  { title: "Sanket", date: "12/12/2025", image: "/svg/News.png" },
  { title: "Sanket", date: "12/12/2025", image: "/svg/News.png" },
  // { title: "Sanket", date: "12/12/2025", image: "/svg/News.png" },
  // { title: "Sanket", date: "12/12/2025", image: "/svg/News.png" },
  // { title: "Sanket", date: "12/12/2025", image: "/svg/News.png" },
  // { title: "Sanket", date: "12/12/2025", image: "/svg/News.png" },
];

const NewsSection = () => {
  const [category, setCategory] = useState("All");

  return (
    <Box p={0} w="100%" mt="52px">
      {/* First Row: Title */}
      <VStack align="start" mb={5} w="100%">
        <Heading color="#101828" fontSize="16px" fontWeight="normal">
        Latest news
        </Heading>
        <Box position="relative">
          <Heading color="#333333" fontSize="13px" textDecoration="underline" fontWeight="normal">
            View all news
          </Heading>
        </Box>
      </VStack>

      {/* News Grid */}
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={5} mt={2}>
        {newsData.map((news, index) => (
          <Box key={index} borderRadius="md" overflow="hidden">
            <Image
              src={news.image}
              alt="News"
              w="100%"
              h="auto"
              objectFit="contain"
            />
            <Box pt={5} pb={5}>
              {/* Title & Date in same line with dot separator */}
              <HStack justify="space-between">
                <Text fontSize="12" color="#344054">
                  {news.title} • {news.date}
                </Text>
              </HStack>

              {/* Main Heading Bold */}
              <Text mt={2} fontSize="16px" color="#101828">
                The balance between print and digital communications
              </Text>

              {/* Subtext Slightly Smaller */}
              <Text mt={2} fontSize="14px" color="#475467">
                Recent research suggests organisations are settling on a blend
                of the two
              </Text>

              {/* Finance Tag - Styled as per your requirement */}
              <Box
                id="finance"
                mt={3}
                w="73px"
                h="24px"
                bg="white"
                border="1px solid #d5d9eb"
                borderRadius="full"
                textAlign="center"
                fontSize="12px"
                color="#363f72"
                display="flex"
                alignItems="center"
                justifyContent="center"
                backgroundColor="#f8f9fc"
                
              >
                Finance
              </Box>
            </Box>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default NewsSection;
